"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneClickType = void 0;
/**
 * 一键登录类型
 */
var OneClickType;
(function (OneClickType) {
    OneClickType[OneClickType["NETEASE_YIDUN"] = 0] = "NETEASE_YIDUN";
})(OneClickType = exports.OneClickType || (exports.OneClickType = {}));
